import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types'
import Button from "./ripple/Button";
import Messages from "./Messages";

export default function RadioButton({
                                        className, title, titlePadding, name, options, onChange, value, disabled, type,
                                        messages, id, description, descriptionPadding
                                    }) {

    const [allowAnimations, setAllowAnimations] = useState(false); // fixes content display on mount

    useEffect(() => {
        setTimeout(() => setAllowAnimations(true), 100)
    }, []);

    return (
        <div className={`radio-container${className ? ' ' + className : ''}`}>
            {
                !!title &&
                <p
                    className='radio-container__title'
                    style={{...(titlePadding ? {'--radio-title-padding': titlePadding} : {})}}
                >
                    {title}
                </p>
            }
            {
                !!description &&
                <p
                    className='radio-container__description'
                    style={{...descriptionPadding ? {'--radio-description-padding': descriptionPadding} : {}}}
                >
                    {description}
                </p>
            }
            <Messages messages={messages} target={id} padding='0 0 5px'/>
            <div className='radio-container__content'>
                {
                    options.map((option, index) => {

                        const isSelected = value === option.value;
                        const selected = isSelected ? ' radio-container__content__option__icon__container--selected' : '';
                        const isDisabled = disabled ? ' radio-container__content__option__icon__container--disabled' : '';
                        const isAnimated = allowAnimations ? '' : ' radio-container__content__option__icon--disable-animations';

                        return (
                            <div className='radio-container__content__option' key={index}>
                                <div className={`radio-container__content__option__icon${isAnimated}`}>
                                    <div
                                        className={`radio-container__content__option__icon__container${isDisabled}${selected}`}
                                    >
                                        <div className='radio-container__content__option__icon__container__circle'/>
                                    </div>
                                </div>
                                <Button
                                    className='radio-container__content__option__button'
                                    name={name}
                                    type={type || 'button'}
                                    value={option.value}
                                    title={!!option.title ? option.title : !!option.value ? '' + option.value : 'Error'}
                                    onClick={e => {
                                        // modify the original synthetic value to allow e.preventDefault and etc.
                                        // dunno how bad is this :3
                                        onChange({...e, ...{target: {...e.target, ...{name, value: option.value}}}})
                                    }}
                                    disabled={disabled}
                                    // iconLeft={`${isSelected ? 'fas' : 'far'} fa-circle`}
                                    displayType={'text'}
                                    visuals={{
                                        borderRadius: '18px',
                                        colorBasic: isSelected ? ['var(--colorAccentBasic)'] : ['var(--colorFontCommon)'],
                                        animationDuration: '400ms',
                                    }}
                                />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

RadioButton.propTypes = {
    title: PropTypes.string,
    titlePadding: PropTypes.string,
    description: PropTypes.string,
    descriptionPadding: PropTypes.string,
    type: PropTypes.string, // html type
    className: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string || undefined,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
}